var it = Object.defineProperty;
var st = (o, t, e) => t in o ? it(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var n = (o, t, e) => (st(o, typeof t != "symbol" ? t + "" : t, e), e);
import k from "dagre";
import ot from "html2canvas";
var c = /* @__PURE__ */ ((o) => (o.REMOVE_SUB_VIEW = "REMOVE_SUB_VIEW", o.ADD_SUB_VIEW = "ADD_SUB_VIEW", o.RESIZE = "RESIZE", o.ADD_NODE = "ADD_NODE", o.REMOVE_NODE = "REMOVE_NODE", o.ADD_EDGE = "ADD_EDGE", o.REMOVE_EDGE = "REMOVE_EDGE", o))(c || {}), f = /* @__PURE__ */ ((o) => (o.SHRINK_NODE = "SHRINK_NODE", o.EXPAND_NODE = "EXPAND_NODE", o.POSITION_CHANGE = "POSITION_CHANGE", o.RESIZE = "RESIZE", o.REMOVED = "REMOVED", o.ADD_CHILD_NODE = "ADD_CHILD_NODE", o))(f || {}), S = /* @__PURE__ */ ((o) => (o.LR = "LR", o.RL = "RL", o.TB = "TB", o.BT = "BT", o))(S || {}), E = /* @__PURE__ */ ((o) => (o.CENTER_OF_BORDER = "CENTER_OF_BORDER", o.CENTER = "CENTER", o))(E || {}), U = /* @__PURE__ */ ((o) => (o.HIERARCHY = "HIERARCHY", o.FLATTEN = "FLATTEN", o))(U || {}), R = /* @__PURE__ */ ((o) => (o.DEFAULT = "DEFAULT", o.WITH_JOINT_NODES = "WITH_JOINT_NODES", o))(R || {});
function nt(o = []) {
  let t = [];
  o.forEach((i) => {
    t = [...t, ...i.dependencies || []];
  });
  const e = new Set(t);
  return o.filter((i) => !e.has(i.id));
}
function ht(o) {
  const t = getComputedStyle(o), e = o.clientHeight - parseFloat(t.paddingTop) - parseFloat(t.paddingBottom), i = o.clientWidth - parseFloat(t.paddingLeft) - parseFloat(t.paddingRight);
  return {
    height: e,
    width: i
  };
}
class A {
  constructor(t, e = !1) {
    n(this, "pElement");
    n(this, "_exists");
    n(this, "withStyle", (t) => (Object.keys(t).forEach((i) => {
      this.pElement.style[i] = t[i];
    }), this));
    n(this, "withAttributes", (t) => (Object.keys(t).forEach((i) => {
      this.pElement.setAttribute(i, t[i]);
    }), this));
    n(this, "withAbsolutePoint", (t) => (this.pElement.style.position = "absolute", this.pElement.style.top = `${t.y}px`, this.pElement.style.left = `${t.x}px`, this));
    n(this, "withAbsolutePosition", (t) => (this.pElement.style.position = "absolute", this.pElement.style.top = `${t.y}px`, this.pElement.style.left = `${t.x}px`, this.pElement.style.width = `${t.width}px`, this.pElement.style.height = `${t.height}px`, this));
    n(this, "withSize", (t) => (this.pElement.style.width = `${t.width}px`, this.pElement.style.height = `${t.height}px`, this));
    n(this, "withWidth", (t) => (this.pElement.style.width = `${t}px`, this));
    n(this, "withHeight", (t) => (this.pElement.style.height = `${t}px`, this));
    n(this, "withClassNames", (...t) => (t.forEach((e) => {
      this.pElement.classList.add(e);
    }), this));
    this.pElement = t, this._exists = e;
  }
  get alreadyExists() {
    return this._exists;
  }
  get htmlElement() {
    return this.pElement;
  }
  get svgElement() {
    return this.pElement;
  }
}
function l(o) {
  return new A(o);
}
function N(o) {
  const t = document.createElement("div");
  return o && o.appendChild(t), new A(t);
}
function T(o, t) {
  let e = o.querySelector(`.${t}`);
  const i = !!e;
  return e || (e = document.createElement("div"), e.classList.add(t), o.appendChild(e)), new A(e, i);
}
function F(o, t) {
  const e = document.createElementNS(
    "http://www.w3.org/2000/svg",
    t
  );
  return o && o.appendChild(e), new A(e);
}
function z(o, t = ":scope>svg", e = "nice-dag-svg-arrow") {
  let i = t ? o.querySelector(t) : null;
  if (!i) {
    i = document.createElementNS("http://www.w3.org/2000/svg", "svg"), i.style.overflow = "hidden";
    const s = document.createElementNS("http://www.w3.org/2000/svg", "defs"), h = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "marker"
    ), r = document.createElementNS("http://www.w3.org/2000/svg", "path");
    h.setAttribute("id", e), h.setAttribute("markerUnits", "strokeWidth"), h.setAttribute("markerWidth", "12"), h.setAttribute("markerHeight", "12"), h.setAttribute("viewBox", "0 0 12 12"), h.setAttribute("refX", "6"), h.setAttribute("refY", "6"), h.setAttribute("orient", "auto"), r.setAttribute("d", "M2,2 L10,6 L2,10 L6,6 L2,2"), r.setAttribute("fill", "#000"), h.appendChild(r), s.appendChild(h), i.appendChild(s), o.appendChild(i);
  }
  return new A(i);
}
function C(o) {
  return !o || o.length === 0;
}
function rt() {
  return Math.random().toString(16).slice(2);
}
function g(o) {
  return o === 1 / 0 ? 1 / 0 : parseInt(`${Math.round(o + Number.EPSILON)}`);
}
function v(o, t) {
  return t === 1 || !t ? o : {
    x: g(o.x / t),
    y: g(o.y / t),
    top: g(o.top / t),
    left: g(o.left / t),
    width: g(o.width / t),
    height: g(o.height / t),
    bottom: g(o.bottom / t),
    right: g(o.right / t)
  };
}
function P(o) {
  const t = o.getBoundingClientRect();
  return {
    x: t.x,
    y: t.y,
    top: t.top,
    left: t.left,
    bottom: t.bottom,
    right: t.right,
    width: t.width,
    height: t.height
  };
}
function dt(o, t) {
  const e = { ...o };
  return Object.keys(t || {}).forEach((s) => e[s] = e[s] || t[s]), e;
}
function at(o, t) {
  return Math.atan(o / t) * 180 / Math.PI;
}
function lt(o) {
  if (!o || o.length === 0)
    return [];
  const t = o.map((s) => ({
    ...s,
    children: []
  })), e = {};
  return t.forEach((s) => {
    e[s.id] = s;
  }), t.forEach((s) => {
    s.parentId && e[s.parentId].children.push(s);
  }), t.forEach((s) => {
    s.children.length === 0 && delete s.children;
  }), t.filter((s) => !s.parentId);
}
function gt(o) {
  return S[o.rankdir || "LR"];
}
function M(o, t) {
  return typeof o < "u" ? o : t;
}
const Z = "nice-dag-node", ct = "nice-dag-edge", b = "data-node-id-key", ft = "nice-dag-svg-bkg-arrow", pt = "nice-dag-svg-background", J = "nice-dag-svg-dnd-arrow", ut = "nice-dag-svg-dnd", yt = "nice-dag-editor-bkg", K = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};
class G {
  constructor(t, e, i, s) {
    n(this, "joint");
    n(this, "editing");
    n(this, "dependencies");
    n(this, "id");
    n(this, "data");
    n(this, "children");
    n(this, "parentId");
    n(this, "collapse");
    n(this, "x");
    n(this, "y");
    n(this, "width");
    n(this, "height");
    n(this, "listeners", []);
    n(this, "ref");
    n(this, "edgeConnectorType");
    n(this, "model");
    n(this, "addNodeChangeListener", (t) => {
      this.listeners.some((e) => e === t) || this.listeners.push(t);
    });
    n(this, "removeNodeChangeListener", (t) => {
      this.listeners = this.listeners.filter((e) => e !== t);
    });
    n(this, "fireNodeChange", (t) => {
      this.listeners.forEach((e) => {
        e.onNodeChange(t);
      });
    });
    this.model = i, this.id = t.id, this.joint = e, this.data = t.data, this.parentId = t.parentId, this.children = t.children, this.dependencies = t.dependencies || [], this.edgeConnectorType = s, this.collapse = t.collapse, this.ref = N().withClassNames(Z).withAttributes({
      [`${b}`]: t.id
    }).htmlElement;
  }
  resize(t) {
    this.width = t.width, this.height = t.height, this.doLayout(), this.fireNodeChange({ type: f.RESIZE, node: this });
  }
  addChildNode(t, e) {
    const i = this.collapse || !this.children || this.children.length === 0;
    this.children || (this.children = []), this.children.push(t), this.fireNodeChange({
      type: f.ADD_CHILD_NODE,
      node: this,
      data: {
        point: e,
        isCollapsed: i,
        sourceNode: t
      }
    });
  }
  removeDependency(t) {
    const e = this.dependencies.some((i) => i === t.id);
    return this.dependencies = this.dependencies.filter((i) => i !== t.id), e;
  }
  connect(t) {
    t != null && t.dependencies.some((e) => e === this.id) || (t.dependencies || (t.dependencies = []), t.dependencies.push(this.id), this.model.addEdge(this, t));
  }
  doLayout() {
    l(this.ref).withAbsolutePosition({
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    });
  }
  setPoint(t, e = !0) {
    this.x = t.x, this.y = t.y, this.ref && (this.ref.style.left = `${this.x}px`, this.ref.style.top = `${this.y}px`), e && this.fireNodeChange({ type: f.POSITION_CHANGE, node: this });
  }
  setBounds(t, e) {
    this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height, this.ref && (this.ref.style.left = `${this.x}px`, this.ref.style.top = `${this.y}px`, this.ref.style.width = `${this.width}px`, this.ref.style.height = `${this.height}px`), e && this.fireNodeChange({ type: f.POSITION_CHANGE, node: this });
  }
  shrink() {
    this.collapse = !0, this.fireNodeChange({ type: f.SHRINK_NODE, node: this });
  }
  expand() {
    this.collapse = !1, this.fireNodeChange({ type: f.EXPAND_NODE, node: this });
  }
  withChildren(t, e = !0) {
    this.children && e ? this.expand() : t.then((i) => {
      this.children = i, this.expand();
    });
  }
  refresh() {
  }
  remove() {
    var t;
    (t = this.ref) == null || t.remove(), this.fireNodeChange({ type: f.REMOVED, node: this }), this.destory();
  }
  destory() {
    this.listeners = [], this.ref = null;
  }
}
const q = {};
function u(o) {
  return o ? q[o] : void 0;
}
function mt(o, t) {
  q[o] = t;
}
const H = 12;
class W {
  constructor(t, e) {
    n(this, "source");
    n(this, "target");
    n(this, "pathRef");
    n(this, "ref");
    this.source = t, this.target = e, this.pathRef = F(null, "path").withAttributes({
      "data-source-key": t.id,
      "data-target-key": e.id
    }).svgElement, this.ref = N().withClassNames(ct).withAbsolutePosition(K).htmlElement, this.source.addNodeChangeListener(this), this.target.addNodeChangeListener(this);
  }
  destory() {
    this.source = null, this.target = null, this.pathRef = null, this.ref = null;
  }
  onNodeChange(t) {
    t.type === f.POSITION_CHANGE || t.type === f.RESIZE || t.type === f.EXPAND_NODE || t.type === f.SHRINK_NODE ? this.doLayout() : t.type === f.REMOVED && (this.remove(), this.destory());
  }
  insertNodes(t, e = 40) {
    const i = this.getInsertNodesStartPosition(t, e);
    this.remove(), this.target.model.addNodes(t, i, e).forEach((h) => {
      this.source.connect(h), h.connect(this.target);
    }), this.destory();
  }
  getInsertNodesStartPosition(t, e) {
    const { graphLabel: i, getNodeSize: s, mapEdgeToPoints: h } = u(this.source.model.dagId).config, { source: r, target: d } = h(this), a = (r.x + d.x) / 2, p = (r.y + d.y) / 2;
    let y = 0, m = 0, L = 0, _ = 0;
    const w = gt(i);
    return t.forEach((et) => {
      const I = s(et);
      w === S.LR || w === S.RL ? m += I.height + e : y += I.width + e, L = Math.max(y, I.width), _ = Math.max(m, I.height);
    }), m -= e, y -= e, w === S.LR || w === S.RL ? {
      x: a - L / 2,
      y: p - m / 2
    } : {
      x: a - y / 2,
      y: p - _ / 2
    };
  }
  remove() {
    this.target.removeDependency(this.source), this.target.model.removeEdge(this), this.target.removeNodeChangeListener(this), this.source.removeNodeChangeListener(this), this.pathRef.remove(), this.ref.remove();
  }
  doLayout() {
    const { mapEdgeToPoints: t } = u(this.source.model.dagId).config, { source: e, target: i } = t(this), s = (e.x + i.x) / 2, h = (e.y + i.y) / 2, r = `M${e.x},${e.y} L${s},${h} L${i.x},${i.y}`;
    l(this.pathRef).withAttributes({
      d: r
    });
    const d = Math.sqrt((i.x - e.x) * (i.x - e.x) + (i.y - e.y) * (i.y - e.y)), a = `rotate(${at(i.y - e.y, i.x - e.x)}deg)`;
    l(this.ref).withAbsolutePosition({
      x: s - d / 2,
      y: h - H / 2,
      width: d,
      height: H
    }).withStyle({
      webkitTransform: a,
      mozTransform: a,
      msTransform: a,
      oTransform: a,
      transform: a
    });
  }
}
function Et(o, t) {
  const e = new k.graphlib.Graph();
  e.setGraph(t), e.setDefaultEdgeLabel(function() {
    return {};
  });
  const i = {};
  for (let s = 0; s < o.length; s++) {
    const h = o[s];
    e.setNode(`${s}`, {
      width: h.width,
      height: h.height
    }), i[h.id] = s;
  }
  return o.forEach((s) => {
    s.dependencies && !C(s.dependencies) && s.dependencies.filter(Boolean).forEach((h) => {
      e.setEdge(i[h], i[s.id]);
    });
  }), k.layout(e), e;
}
class $ {
  constructor({ dagId: t, parentNode: e, nodes: i, vmConfig: s, isRootModel: h }) {
    n(this, "vNodes");
    n(this, "pChildVMs");
    n(this, "_parentNode");
    n(this, "vmConfig");
    n(this, "pEdges");
    n(this, "pSize");
    n(this, "listeners", []);
    n(this, "isRootModel");
    n(this, "_dagId");
    n(this, "onNodeChange", (t) => {
      if (t.type === f.EXPAND_NODE)
        this.setNodeCollapse(t.node, !1);
      else if (t.type === f.SHRINK_NODE)
        this.setNodeCollapse(t.node, !0);
      else if (t.type === f.ADD_CHILD_NODE) {
        const { isCollapsed: e, point: i, sourceNode: s } = t.data;
        this.fireModelChange({
          source: this,
          originalSource: t.node,
          type: c.ADD_NODE
        }), e ? this.setNodeCollapse(t.node, !1) : this.pChildVMs.find((r) => r.id === t.node.id).addNode(s, i);
      } else
        t.type === f.POSITION_CHANGE || t.type === f.RESIZE ? this.doLayout(!0, !1) : t.type === f.REMOVED && (this.pChildVMs = this.pChildVMs.filter((e) => e.id !== t.node.id), this.vNodes = this.vNodes.filter((e) => e.id !== t.node.id), this.pEdges = this.pEdges.filter((e) => !(e.source.id === t.node.id || e.target.id === t.node.id)), this.fireModelChange({
          source: this,
          originalSource: t.node,
          type: c.REMOVE_NODE
        }));
    });
    n(this, "addModelChangeListener", (t) => {
      this.listeners.some((e) => e === t) || this.listeners.push(t);
    });
    n(this, "removeNodeChangeListener", (t) => {
      this.listeners = this.listeners.filter((e) => e === t);
    });
    n(this, "isSubViewNode", (t) => {
      var e;
      return !C((e = this.pChildVMs) == null ? void 0 : e.filter((i) => i.id === t));
    });
    n(this, "findNodeById", (t) => {
      let e = this.vNodes.find((i) => i.id === t);
      if (!e && !C(this.pChildVMs))
        for (let i = 0; i < this.pChildVMs.length && (e = this.pChildVMs[i].findNodeById(t), !e); i++)
          ;
      return e;
    });
    n(this, "init", (t) => {
      this.buildVNodes(t), this.buildEdges(), this.doLayout(!1, !1);
    });
    n(this, "setNodeCollapse", (t, e) => {
      let i;
      const { getNodeSize: s } = u(this.dagId).config;
      if (e)
        this.pChildVMs = this.pChildVMs.filter((r) => r.id !== t.id), i = s(t);
      else {
        const r = this.createChildVm(t, t.children);
        this.pChildVMs = [...this.pChildVMs.filter((d) => d.id !== r.id), r], i = r.size();
      }
      t.width = i.width, t.height = i.height;
      const h = t.editing;
      t.editing = !1, this.doLayout(!0, !1), t.editing = h, this.fireModelChange({
        source: this,
        originalSource: t,
        type: e ? c.REMOVE_SUB_VIEW : c.ADD_SUB_VIEW
      }), u(this._dagId).fireNiceDagChange();
    });
    n(this, "fireModelChange", (t) => {
      this.listeners.forEach((e) => {
        e.onModelChange(t);
      });
    });
    n(this, "withJointNodes", () => {
      const t = [], e = nt(this.vNodes), i = /* @__PURE__ */ new Set();
      return this.vNodes.forEach((s) => {
        var r;
        const h = e.some((d) => d.id === s.id);
        if (((r = s.dependencies) == null ? void 0 : r.length) > 1 && !h) {
          const d = `joint-${s.dependencies.join("-")}`;
          if (!i.has(d)) {
            const a = new G({
              id: d,
              dependencies: s.dependencies
            }, !0, this, this.vmConfig.jointEdgeConnectorType);
            a.addNodeChangeListener(this), t.push(a), i.add(d);
          }
          s.dependencies = [d];
        }
      }), [...this.vNodes, ...t];
    });
    n(this, "buildVNodes", (t) => {
      this.vNodes = t.map((e) => this.toViewNode(e)), this.vmConfig.mode === R.WITH_JOINT_NODES && (this.vNodes = this.withJointNodes()), this.withNodeSize();
    });
    n(this, "withNodeSize", () => {
      const t = {}, { getNodeSize: e } = u(this.dagId).config;
      this.pChildVMs.forEach((i) => t[i.id] = i), this.vNodes.forEach((i) => {
        const s = t[i.id] && !i.collapse ? t[i.id].size() : e(i);
        i.width = s.width, i.height = s.height;
      });
    });
    n(this, "resize", (t) => {
      const e = this.pSize, i = this.vmConfig.subViewPadding;
      let s = 0, h = 0;
      this.vNodes.forEach((r) => {
        s = Math.max(r.x + r.width, s), h = Math.max(r.y + r.height, h);
      }), this.isRoot ? this.pSize = {
        width: s,
        height: h
      } : this.pSize = {
        width: s + i.left + i.right,
        height: h + i.top + i.bottom
      }, t && (this.pSize.width !== e.width || this.pSize.height !== e.height) && this.fireModelChange({
        source: this,
        type: c.RESIZE
      });
    });
    n(this, "doLayout", (t, e) => {
      e && this.childVMs.forEach((h) => {
        h.doLayout(t, e), this.vNodes.find((r) => r.id === h.id).resize(h.size());
      });
      const i = Et(this.vNodes, u(this.dagId).config.graphLabel);
      let s = 0;
      this.vNodes.forEach((h) => {
        if (!h.editing) {
          const r = i.node(String(s)), { width: d, height: a } = h, p = r.x - d / 2, y = r.y - a / 2;
          h.x = p, h.y = y, h.doLayout();
        }
        s++;
      }), this.resize(t), this.pEdges.forEach((h) => {
        h.doLayout();
      });
    });
    n(this, "buildEdges", () => {
      this.pEdges = [];
      const t = {};
      this.vNodes.forEach((e) => t[e.id] = e), this.vNodes.forEach((e) => {
        C(e.dependencies) || e.dependencies.forEach((i) => {
          this.pEdges.push(new W(t[i], e));
        });
      });
    });
    n(this, "size", (t = !0) => {
      if (t || this.isRoot)
        return this.pSize;
      const e = this.vmConfig.subViewPadding;
      return {
        width: this.pSize.width - e.left - e.right,
        height: this.pSize.height - e.top - e.bottom
      };
    });
    const r = i;
    this._dagId = t, this._parentNode = e, this.vmConfig = s, this.isRootModel = h, this.pChildVMs = r.filter((d) => !d.collapse && !C(d.children)).map(
      (d) => this.createChildVm(d, d.children)
    ), this.init(r);
  }
  setRootOffset({ offsetX: t, offsetY: e }) {
    if (this.isRoot)
      this.vNodes.forEach((i) => {
        i.x += t, i.y += e, i.doLayout();
      }), this.pEdges.forEach((i) => {
        i.doLayout();
      });
    else
      throw new Error("Sub model doesn't support the method.");
  }
  addNodes(t, e, i = 40) {
    let s = 0;
    const { getNodeSize: h } = u(this.dagId).config;
    return t.map((r) => {
      const d = h(r), a = {
        x: e.x,
        y: e.y + s
      };
      return s += i + d.height, this.addNode(r, a);
    });
  }
  addNode(t, e, i) {
    const s = this.toViewNode(t);
    s.editing = !0, s.joint = i;
    const { getNodeSize: h } = u(this.dagId).config;
    this.vNodes.push(s);
    const r = h(s);
    return s.width = r.width, s.height = r.height, s.x = e.x, s.y = e.y, this.fireModelChange({
      source: this,
      originalSource: s,
      type: c.ADD_NODE
    }), !t.collapse && !C(t.children) ? s.expand() : (s.fireNodeChange({ type: f.POSITION_CHANGE, node: s }), u(this._dagId).fireNiceDagChange()), s;
  }
  destory() {
    this.vNodes.forEach((t) => t.destory()), this.pEdges.forEach((t) => t.destory()), this.pChildVMs.forEach((t) => t.destory()), this.listeners = [];
  }
  removeEdge(t) {
    return this.pEdges.some((e) => e === t) ? (this.pEdges = this.pEdges.filter((e) => e !== t), u(this._dagId).fireNiceDagChange(), !0) : !1;
  }
  refreshJointNodes() {
    if (this.vmConfig.mode === R.WITH_JOINT_NODES) {
      const t = this.vNodes.filter((s) => s.joint && s.dependencies.length === 1), e = new Set(t.map((s) => s.id)), i = this.vNodes.filter((s) => s.dependencies.some((h) => e.has(h)));
      t.forEach((s) => {
        const { dependencies: h } = s, r = this.findNodeById(h[0]);
        i.filter((a) => a.dependencies.some((p) => p === s.id)).forEach((a) => {
          a.dependencies.push(r.id), this.createEdgeAndFireModelChange(r, a);
        });
      }), t.forEach((s) => {
        s.remove();
      });
    }
  }
  createEdgeAndFireModelChange(t, e) {
    const i = new W(t, e);
    return this.pEdges.push(i), this.fireModelChange({
      source: this,
      originalSource: i,
      type: c.ADD_EDGE
    }), i.doLayout(), i;
  }
  findPrecedentedNodes(t) {
    return this.pEdges.filter((e) => e.target.id === t.id).map((e) => this.findNodeById(e.source.id));
  }
  addEdge(t, e) {
    const i = this.createEdgeAndFireModelChange(t, e);
    return u(this._dagId).fireNiceDagChange(), i;
  }
  onModelChange(t) {
    t.source.id !== this.id && t.type === c.RESIZE && this.vNodes.find((i) => i.id === t.source.id).resize(t.source.size());
  }
  createChildVm(t, e) {
    const i = new $({
      dagId: this._dagId,
      parentNode: t,
      nodes: e,
      vmConfig: this.vmConfig
    });
    return i.addModelChangeListener(this), i;
  }
  get isRoot() {
    return this.isRootModel;
  }
  getAllNodes() {
    var e;
    let t = [...this.vNodes];
    return (e = this.pChildVMs) == null || e.forEach((i) => {
      t = [...t, ...i.getAllNodes()];
    }), t;
  }
  getAllEdges() {
    var e;
    let t = [...this.edges];
    return (e = this.pChildVMs) == null || e.forEach((i) => {
      t = [...t, ...i.getAllEdges()];
    }), t;
  }
  get dagId() {
    return this._dagId;
  }
  toViewNode(t) {
    const e = new G(t, !1, this, t.edgeConnectorType || this.vmConfig.edgeConnectorType);
    return e.addNodeChangeListener(this), e;
  }
  get subViewPadding() {
    return this.vmConfig.subViewPadding;
  }
  get parentNode() {
    return this._parentNode;
  }
  get id() {
    var t;
    return (t = this._parentNode) == null ? void 0 : t.id;
  }
  get() {
    return this.pSize;
  }
  get childVMs() {
    return this.pChildVMs;
  }
  get nodes() {
    return this.vNodes;
  }
  get edges() {
    return this.pEdges;
  }
}
const V = {
  rankdir: "LR",
  ranksep: 60,
  edgesep: 10
}, wt = {
  color: "blue",
  size: 40
}, xt = {
  top: 40,
  bottom: 20,
  left: 20,
  right: 20
}, Ct = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
}, Nt = {
  color: "black"
};
function x(o) {
  return {
    x: o.x + o.width / 2,
    y: o.y + o.height / 2
  };
}
const X = {
  LR: ({ source: o, target: t }) => {
    const e = o.edgeConnectorType === E.CENTER ? x(o) : {
      x: o.x + o.width,
      y: o.y + o.height / 2
    }, i = t.edgeConnectorType === E.CENTER ? x(t) : { x: t.x, y: t.y + t.height / 2 };
    return {
      source: e,
      target: i
    };
  },
  RL: ({ source: o, target: t }) => {
    const e = o.edgeConnectorType === E.CENTER ? x(o) : { x: o.x, y: o.y + o.height / 2 }, i = t.edgeConnectorType === E.CENTER ? x(t) : {
      x: t.x + t.width,
      y: t.y + t.height / 2
    };
    return {
      source: e,
      target: i
    };
  },
  BT: ({ source: o, target: t }) => {
    const e = o.edgeConnectorType === E.CENTER ? x(o) : { x: o.x + o.width / 2, y: o.y }, i = t.edgeConnectorType === E.CENTER ? x(t) : {
      x: t.x + t.width / 2,
      y: t.y + t.height
    };
    return {
      source: e,
      target: i
    };
  },
  TB: ({ source: o, target: t }) => {
    const e = o.edgeConnectorType === E.CENTER ? x(o) : {
      x: o.x + o.width / 2,
      y: o.y + o.height
    }, i = t.edgeConnectorType === E.CENTER ? x(t) : { x: t.x + t.width / 2, y: t.y };
    return {
      source: e,
      target: i
    };
  }
};
function Lt(o) {
  return o ? {
    ...o,
    rankdir: o.rankdir || V.rankdir,
    ranksep: o.ranksep || V.ranksep,
    edgesep: o.edgesep || V.edgesep
  } : V;
}
function _t(o, t = Ct) {
  return {
    top: M(o == null ? void 0 : o.top, t.top),
    left: M(o == null ? void 0 : o.left, t.left),
    bottom: M(o == null ? void 0 : o.bottom, t.bottom),
    right: M(o == null ? void 0 : o.right, t.right)
  };
}
function St() {
  return Nt;
}
const Dt = {
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  zIndex: "9999",
  display: "none",
  "user-select": "none",
  cursor: "pointer"
}, Bt = "minimap-dnd-glass";
class vt {
  constructor(t) {
    n(this, "scale");
    n(this, "viewBoxScale");
    n(this, "viewBoxInitX");
    n(this, "viewBoxInitY");
    n(this, "mainLayer");
    n(this, "zoomLayer");
    n(this, "minimapContent");
    n(this, "viewBoxElm");
    n(this, "viewBoxClassname");
    n(this, "canvas");
    n(this, "dndGlass");
    n(this, "initClientX");
    n(this, "initClientY");
    n(this, "listeners", []);
    n(this, "parentContainer");
    n(this, "contentContainer");
    n(this, "onCanvasReady", (t) => {
      const { mainLayer: e, zoomLayer: i, viewBoxElm: s, minimapContent: h, scale: r } = this, d = e.scrollLeft, a = e.scrollTop, p = e.offsetWidth > i.offsetWidth ? 1 : e.offsetWidth / i.offsetWidth, y = e.offsetHeight > i.offsetHeight ? 1 : e.offsetHeight / i.offsetHeight, m = Math.ceil(t.width * p), L = Math.ceil(t.height * y), _ = Math.ceil(d * r * p), w = Math.ceil(a * r * y);
      l(s).withStyle({
        border: "1px red solid",
        position: "absolute",
        width: `${m}px`,
        height: `${L}px`,
        left: `${_}px`,
        top: `${w}px`,
        cursor: "pointer",
        zIndex: 999,
        display: "block"
      }), h.appendChild(s), h.appendChild(t);
    });
    n(this, "updateViewBoxPosition", () => {
      const t = this.mainLayer.scrollLeft, e = this.mainLayer.scrollTop, i = this.canvas.width - this.viewBoxElm.offsetWidth, s = this.canvas.height - this.viewBoxElm.offsetHeight;
      let h = this.scale * t;
      h = Math.max(0, h), h = Math.min(h, i);
      let r = this.scale * e;
      r = Math.max(0, r), r = Math.min(r, s), l(this.viewBoxElm).withStyle({
        left: `${Math.ceil(h)}px`,
        top: `${Math.ceil(r)}px`
      });
    });
    n(this, "startViewBoxDragging", (t) => {
      this.initClientX = t.clientX, this.initClientY = t.clientY, this.viewBoxInitX = this.viewBoxElm.offsetLeft, this.viewBoxInitY = this.viewBoxElm.offsetTop, l(this.dndGlass).withStyle({
        display: "block"
      });
    });
    n(this, "onViewBoxDragging", (t) => {
      const e = t.clientX - this.initClientX, i = t.clientY - this.initClientY, s = this.canvas.width - this.viewBoxElm.offsetWidth / this.viewBoxScale, h = this.canvas.height - this.viewBoxElm.offsetHeight / this.viewBoxScale;
      let r = this.viewBoxInitX + e, d = this.viewBoxInitY + i;
      r = Math.max(0, r), r = Math.min(r, s), d = Math.max(0, d), d = Math.min(d, h), this.viewBoxElm.style.left = `${Math.ceil(r)}px`, this.viewBoxElm.style.top = `${Math.ceil(d)}px`, this.listeners.forEach((a) => {
        a.onMinimapDragging({ scrollLeft: r / this.scale, scrollTop: d / this.scale });
      });
    });
    n(this, "onViewBoxDraggingEnd", () => {
      l(this.dndGlass).withStyle({
        display: "none"
      });
    });
    this.viewBoxScale = 1, this.mainLayer = t.mainLayer, this.zoomLayer = t.zoomLayer, this.parentContainer = t.container, this.viewBoxElm = this.createViewBoxElement(t == null ? void 0 : t.viewBoxClassName), this.canvas = document.createElement("canvas"), this.contentContainer = N(this.parentContainer).withStyle({
      position: "relative",
      width: "100%",
      height: "100%",
      display: "flex",
      "justify-content": "center",
      "place-content": "center",
      "align-content": "center",
      "flex-wrap": "nowrap",
      "flex-direction": "column",
      "align-items": "center"
    }).htmlElement, this.minimapContent = this.createMinimapElement(t == null ? void 0 : t.className);
    const e = T(this.mainLayer, Bt).withStyle(Dt);
    e.htmlElement.addEventListener("mousemove", this.onViewBoxDragging), e.htmlElement.addEventListener("mouseup", this.onViewBoxDraggingEnd), this.dndGlass = e.htmlElement;
  }
  addMinimapListener(t) {
    this.listeners.push(t);
  }
  createMinimapElement(t) {
    const e = N(this.contentContainer).withClassNames("nice-dag-minimap").withStyle({
      position: "relative"
    }).htmlElement;
    return t && e.classList.add(t), e;
  }
  createViewBoxElement(t) {
    const e = N(this.contentContainer).withClassNames("nice-dag-minimap").withStyle({
      position: "relative"
    }).htmlElement;
    return e.classList.add("nice-dag-minimap-viewbox"), t && e.classList.add(t), e.addEventListener("mousedown", this.startViewBoxDragging), e;
  }
  calcRatio() {
    const t = ht(this.parentContainer), i = this.zoomLayer.getBoundingClientRect();
    i.width / i.height > 1 ? this.scale = t.width / i.width : this.scale = t.height / i.height;
  }
  useWidth() {
    const e = this.zoomLayer.getBoundingClientRect();
    return e.width / e.height > 1;
  }
  render() {
    this.clear(), this.calcRatio();
    const t = this.parentContainer.getBoundingClientRect(), e = this.zoomLayer, i = e.getBoundingClientRect().width * this.scale, s = e.getBoundingClientRect().height * this.scale, { viewBoxElm: h } = this;
    l(h).withStyle({
      display: "none"
    }), this.useWidth() ? (this.canvas.style.width = "100%", l(this.minimapContent).withStyle({
      width: "100%",
      height: "auto"
    }), this.canvas.style.top = `${g((t.height - s) / 2)}px`) : (this.canvas.style.height = "100%", l(this.minimapContent).withStyle({
      width: "auto",
      height: "100%"
    }), this.canvas.style.left = `${g((t.width - i) / 2)}px`), this.canvas.width = Math.ceil(i), this.canvas.height = Math.ceil(s);
    const r = setTimeout(() => {
      window.clearTimeout(r), ot(
        e,
        {
          useCORS: !0,
          scale: this.scale,
          canvas: this.canvas,
          scrollY: 0,
          scrollX: 0
        }
      ).then(this.onCanvasReady);
    }, 50);
  }
  destory() {
    this.listeners = [], this.clear();
  }
  clear() {
    this.canvas.getContext("2d").clearRect(0, 0, this.canvas.width, this.canvas.height);
  }
  setViewBoxScale(t) {
    this.viewBoxScale = t;
    let e = this.viewBoxElm;
    const i = this.canvas.width / e.offsetWidth, s = this.canvas.height / e.offsetHeight, h = Math.min(1 / t, i), r = Math.min(1 / t, s);
    e.style.transform = `scale(${h}, ${r})`, e.style.transformOrigin = "left top";
  }
}
const Rt = "nice-dag-main-layer", Tt = "nice-dag-zoom-layer", Q = "nice-dag-content-layer", bt = "nice-dag-nodes-layer", At = {
  position: "relative",
  height: "100%",
  width: "100%"
};
function It(o) {
  const t = Lt(o.graphLabel), e = _t(o.subViewPadding, xt);
  return {
    ...o,
    getEdgeAttributes: o.getEdgeAttributes || St,
    graphLabel: t,
    mode: o.mode || R.WITH_JOINT_NODES,
    subViewPadding: e,
    gridConfig: dt(o.gridConfig, wt),
    edgeConnectorType: o.edgeConnectorType || E.CENTER_OF_BORDER,
    jointEdgeConnectorType: o.jointEdgeConnectorType || E.CENTER
  };
}
class O {
  constructor({ viewConfig: t, model: e }) {
    n(this, "nodesLayer");
    n(this, "contentLayer");
    n(this, "svgLayer");
    n(this, "viewConfig");
    n(this, "subViews");
    n(this, "model");
    n(this, "appendNode", (t) => {
      this.nodesLayer.appendChild(t.ref), this.viewConfig.mapNodeToElement && t.ref.appendChild(this.viewConfig.mapNodeToElement(t));
    });
    n(this, "getContentElement", () => this.contentLayer);
    n(this, "getEdgeLabel", (t, e) => {
      throw new Error(`Can't support the method with ${t}, ${e}`);
    });
    n(this, "renderEdge", (t) => {
      const e = t.pathRef, i = this.viewConfig.getEdgeAttributes(t), s = l(e).withAttributes({
        stroke: i && i.color ? i.color : "rgb(204, 204, 204)"
      }).svgElement;
      i.hideArrow || s.setAttribute("marker-mid", `url(#${this.model.dagId}-nice-dag-svg-arrow)`);
    });
    n(this, "getNodeLayerSizeStyle", () => {
      const t = this.model.size(!1);
      return {
        position: "relative",
        width: `${t.width}px`,
        height: `${t.height}px`,
        "z-index": "1"
      };
    });
    n(this, "getContentLayerStyle", () => {
      const t = this.model.size();
      return {
        position: "absolute",
        top: 0,
        left: 0,
        height: `${t.height}px`,
        width: `${t.width}px`
      };
    });
    n(this, "render", (t) => {
      if (!this.model.isRoot) {
        const i = this.viewConfig.subViewPadding;
        l(t).withStyle({
          "padding-top": `${i.top}px`,
          "padding-bottom": `${i.bottom}px`,
          "padding-left": `${i.left}px`,
          "padding-right": `${i.right}px`
        });
      }
      this.nodesLayer = N(t).withStyle(this.getNodeLayerSizeStyle()).withClassNames(bt).htmlElement, this.svgLayer = z(this.nodesLayer, null, `${this.model.dagId}-nice-dag-svg-arrow`).withAttributes(
        {
          width: "100%",
          height: "100%"
        }
      ).svgElement, this.contentLayer = N(t).withStyle(this.getContentLayerStyle()).withClassNames(Q).htmlElement, this.appendViewElement(this.model.parentNode, this.contentLayer);
      const e = {};
      this.model.nodes.forEach((i) => {
        this.appendNode(i), !C(i.children) && !i.collapse && (e[i.id] = i.ref, i.ref.setAttribute("data-subview-key", "true"));
      }), this.model.edges.forEach((i) => {
        this.svgLayer.appendChild(i.pathRef), this.nodesLayer.appendChild(i.ref), this.renderEdge(i);
      }), C(this.subViews) || this.subViews.forEach((i) => {
        i.render(e[i.model.id]);
      });
    });
    n(this, "appendViewElement", (t, e) => {
      if (this.viewConfig.getViewElement) {
        const i = this.viewConfig.getViewElement(t);
        i && e.appendChild(i);
      }
    });
    n(this, "resize", () => {
      l(this.nodesLayer).withStyle(this.getNodeLayerSizeStyle()), l(this.contentLayer).withStyle(this.getContentLayerStyle());
    });
    n(this, "destory", () => {
      this.clear(), this.model.removeNodeChangeListener(this);
    });
    var i;
    this.viewConfig = t, this.model = e, this.model.addModelChangeListener(this), this.subViews = (i = this.model.childVMs) == null ? void 0 : i.map((s) => new O({ viewConfig: t, model: s }));
  }
  justifySize(t) {
    t.width > 0 && (this.nodesLayer.style.width = `${t.width}px`, this.contentLayer.style.width = `${t.width}px`), t.height > 0 && (this.nodesLayer.style.height = `${t.height}px`, this.contentLayer.style.height = `${t.height}px`);
  }
  clear() {
    var t, e;
    l(this.nodesLayer.parentElement).withStyle({
      "padding-top": 0,
      "padding-bottom": 0,
      "padding-left": 0,
      "padding-right": 0
    }), (t = this.nodesLayer) == null || t.remove(), (e = this.contentLayer) == null || e.remove();
  }
  onModelChange(t) {
    var e, i, s;
    if (t.type === c.REMOVE_SUB_VIEW)
      ((e = this.subViews) == null ? void 0 : e.find((r) => r.model.id === t.originalSource.id)).destory(), this.subViews = (i = this.subViews) == null ? void 0 : i.filter((r) => r.model.id !== `${t.originalSource.id}`);
    else if (t.type === c.ADD_SUB_VIEW) {
      const h = {};
      this.subViews.forEach((r) => h[r.model.id] = r), this.subViews = (s = this.model.childVMs) == null ? void 0 : s.map((r) => {
        let d = h[r.id];
        if (!d) {
          const a = new O({ viewConfig: this.viewConfig, model: r }), p = this.nodesLayer.querySelector(`[${b}='${t.originalSource.id}']`);
          a.render(p), d = a;
        }
        return d;
      });
    } else
      t.type === c.RESIZE ? this.resize() : t.type === c.ADD_EDGE ? (this.svgLayer.appendChild(t.originalSource.pathRef), this.nodesLayer.appendChild(t.originalSource.ref), t.originalSource.doLayout(), this.renderEdge(t.originalSource)) : t.type === c.ADD_NODE && (t.originalSource.doLayout(), this.nodesLayer.appendChild(t.originalSource.ref));
  }
  getAllNodes() {
    return this.model.getAllNodes();
  }
  getAllEdges() {
    return this.model.getAllEdges();
  }
}
class tt {
  constructor(t) {
    n(this, "_rootContainer");
    n(this, "zoomLayer");
    n(this, "_config");
    n(this, "mainLayer");
    n(this, "rootView");
    n(this, "minimap");
    n(this, "rootModel");
    n(this, "uid");
    n(this, "listeners", []);
    n(this, "parentSize");
    n(this, "_scale");
    n(this, "useDefaultMapEdgeToPoints");
    n(this, "destoried");
    n(this, "getRootContentElement", () => this.rootView.getContentElement());
    n(this, "findNodeById", (t) => this.rootModel.findNodeById(t));
    n(this, "getElementByNodeId", (t) => {
      let e = this.zoomLayer.querySelector(`[${b}='${t}']>.${Q}`);
      return e || (e = this.zoomLayer.querySelector(`[${b}='${t}']`)), e;
    });
    n(this, "getEdgeLabel", (t, e) => this.rootView.getEdgeLabel(t, e));
    n(this, "scrollTo", (t) => {
      const e = this.getElementByNodeId(t), i = this.rootContainer.getBoundingClientRect();
      if (e) {
        const s = e.getBoundingClientRect();
        this.mainLayer.scrollTop += s.y - i.y - i.height / 2, this.mainLayer.scrollLeft += s.x - i.x;
      }
    });
    n(this, "getScrollPosition", () => ({
      x: this.mainLayer.scrollLeft,
      y: this.mainLayer.scrollTop
    }));
    n(this, "fireNiceDagChange", () => {
      this.listeners.forEach((t) => t.onChange()), this.fireMinimapChange();
    });
    n(this, "fireMinimapChange", () => {
      var t;
      (t = this.minimap) == null || t.render();
    });
    n(this, "addNiceDagChangeListener", (t) => (this.listeners.every((e) => e !== t) && this.listeners.push(t), !1));
    n(this, "removeNiceDagChangeListener", (t) => (this.listeners.some((e) => e === t) && (this.listeners = this.listeners.filter((e) => e === t)), !1));
    n(this, "onMainLayerScroll", () => {
      var t;
      (t = this.minimap) == null || t.updateViewBoxPosition();
    });
    this.uid = t.id || rt();
    const { container: e, minimapContainer: i, minimapConfig: s, ...h } = It(t);
    this._config = h, this._config.mapEdgeToPoints = t.mapEdgeToPoints, this._config.mapEdgeToPoints || (this._config.mapEdgeToPoints = X[this._config.graphLabel.rankdir], this.useDefaultMapEdgeToPoints = !0), this._rootContainer = e, this.mainLayer = T(this.rootContainer, Rt).withStyle(
      { ...At, overflow: "auto" }
    ).htmlElement, this.mainLayer.addEventListener("scroll", this.onMainLayerScroll), this.zoomLayer = T(this.mainLayer, Tt).withStyle(
      {
        position: "absolute",
        "z-index": 1
      }
    ).htmlElement, i && (this.minimap = new vt({
      mainLayer: this.mainLayer,
      zoomLayer: this.zoomLayer,
      container: i,
      ...s
    }), this.minimap.addMinimapListener(this));
  }
  setDirection(t) {
    this._config.graphLabel.rankdir = t, this.useDefaultMapEdgeToPoints && (this._config.mapEdgeToPoints = X[this._config.graphLabel.rankdir]), this.prettify();
  }
  prettify() {
    this.rootModel.doLayout(!0, !0), this.justifyCenter(this.parentSize), this.fireMinimapChange();
  }
  onMinimapDragging(t) {
    const { scrollLeft: e, scrollTop: i } = t;
    this.mainLayer.scrollTop = i, this.mainLayer.scrollLeft = e;
  }
  onModelChange(t) {
    t.type === c.RESIZE && l(this.zoomLayer).withSize(this.rootView.model.size()), (t.type === c.RESIZE || t.type === c.ADD_SUB_VIEW || t.type === c.REMOVE_SUB_VIEW) && this.justifyCenter(this.parentSize);
  }
  get config() {
    return this._config;
  }
  get rootContainer() {
    return this._rootContainer;
  }
  get id() {
    return this.uid;
  }
  center(t) {
    return this.parentSize = t, this.justifyCenter(this.parentSize), this.fireMinimapChange(), this;
  }
  justifyCenter(t) {
    if (t) {
      const e = this.zoomLayer.getBoundingClientRect();
      let i = 0, s = 0;
      t.width > e.width && (i = (t.width - e.width) / 2), t.height > e.height && (s = (t.height - e.height) / 2), this.zoomLayer.style.left = `${i}px`, this.zoomLayer.style.top = `${s}px`;
    }
  }
  withNodes(t) {
    var s, h, r, d;
    (s = this.rootModel) == null || s.destory(), this.destoried ? (d = this.minimap) == null || d.addMinimapListener(this) : ((h = this.rootView) == null || h.clear(), (r = this.minimap) == null || r.clear());
    const e = this.config.modelType === U.FLATTEN ? lt(t) : t, i = JSON.parse(JSON.stringify(e));
    return this.rootModel = new $({
      dagId: this.uid,
      parentNode: {
        id: "root"
      },
      nodes: i,
      vmConfig: this.config,
      isRootModel: !0
    }), this.rootView = new O({
      model: this.rootModel,
      viewConfig: this.config
    }), this.rootModel.addModelChangeListener(this), this.destoried = !1, this;
  }
  getAllNodes() {
    return this.rootView.getAllNodes();
  }
  getAllEdges() {
    return this.rootView.getAllEdges();
  }
  render() {
    var t;
    this.rootView.render(this.zoomLayer), (t = this.minimap) == null || t.render(), l(this.zoomLayer).withAbsolutePosition(
      {
        x: 0,
        y: 0,
        ...this.rootView.model.size()
      }
    ), this.parentSize && this.justifyCenter(this.parentSize);
  }
  get isDestoried() {
    return this.destoried;
  }
  destory() {
    var t;
    this.destoried = !0, this.listeners = [], this.rootView.destory(), (t = this.minimap) == null || t.destory();
  }
  setScale(t) {
    this._scale = t, this.zoomLayer.style.transform = `scale(${t})`, this.zoomLayer.style.transformOrigin = "left top", this.zoomLayer.setAttribute("data-zoom-ratio-key", `${t}`), this.parentSize && this.justifyCenter(this.parentSize), this.minimap && this.minimap.setViewBoxScale(t);
  }
  get scale() {
    return this._scale || 1;
  }
}
var D = /* @__PURE__ */ ((o) => (o.LeftToRight = "LeftToRight", o.RightToLeft = "RightToLeft", o.None = "None", o))(D || {}), B = /* @__PURE__ */ ((o) => (o.TopToBottom = "TopToBottom", o.BottomToTop = "BottomToTop", o.None = "None", o))(B || {});
const Mt = "dnd-glass", Vt = {
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  zIndex: "9999",
  display: "none",
  "user-select": "none"
};
function Ot(o, t) {
  return t.x <= o.x && t.y <= o.y && t.right >= o.x && t.bottom >= o.y;
}
class Y {
  constructor(t, e, i) {
    n(this, "_rootContainer");
    n(this, "_glassStyles");
    n(this, "draggingNode");
    n(this, "draggingElement");
    n(this, "_enabled");
    n(this, "editableGlass");
    n(this, "context");
    n(this, "isDraggingEdge");
    n(this, "mapEdgeToPoints");
    n(this, "draggingNodeParentBounds");
    n(this, "eligibleEdgeConnectors", []);
    n(this, "originalScrollPosition");
    n(this, "buildGlass", () => {
      var e;
      const t = T(document.body, Mt).withStyle({
        ...Vt,
        cursor: ((e = this._glassStyles) == null ? void 0 : e.cursor) || "pointer"
      });
      t.alreadyExists || (t.htmlElement.addEventListener("mousemove", this.onDragging), t.htmlElement.addEventListener("mouseup", this.endDragging)), this.editableGlass = t.htmlElement;
    });
    n(this, "setEnabled", (t) => {
      this._enabled = t;
    });
    n(this, "initContext", (t) => {
      this.originalScrollPosition = {
        x: this._rootContainer.scrollLeft,
        y: this._rootContainer.scrollTop
      }, this.draggingNode = t, this.draggingNodeParentBounds = P(t.ref.parentElement);
      const e = t.ref.parentElement.querySelectorAll(`:scope>.${Z}`);
      this.eligibleEdgeConnectors = [], e.forEach((i) => {
        i !== t.ref && this.eligibleEdgeConnectors.push(
          {
            viewNode: t.model.findNodeById(i.getAttribute(b)),
            bounds: P(i)
          }
        );
      });
    });
    n(this, "withContext", (t) => (this.context = t, this));
    n(this, "startNodeDragging", (t, e) => {
      if (this._enabled) {
        l(this.editableGlass).withStyle({
          display: "block"
        }), this.initContext(t), this.updateRelativeMousePoint({
          x: e.pageX,
          y: e.pageY
        }), this.draggingElement = l(t.ref.cloneNode(!0)).withStyle({
          transform: `scale(${this.context.provider.scale})`,
          transformOrigin: "top left"
        }).htmlElement;
        const i = this.context.lastBounds();
        l(this.draggingElement).withStyle({
          "user-select": "none",
          "z-index": 9
        }).withAbsolutePoint({
          x: i.left,
          y: i.top
        }), this.editableGlass.appendChild(this.draggingElement);
      }
    });
    n(this, "startEdgeDragging", (t, e) => {
      if (this._enabled) {
        l(this.editableGlass).withStyle({
          display: "block"
        }), this.isDraggingEdge = !0;
        const i = this.context.provider.svgDndBackground;
        this.draggingElement = F(i, "path").withAttributes({
          stroke: "rgb(204, 204, 204)",
          "marker-mid": `url(#${t.model.dagId}-${J})`
        }).svgElement, this.initContext(t), this.updateRelativeMousePoint({
          x: e.pageX,
          y: e.pageY
        });
      }
    });
    n(this, "onDragging", (t) => {
      if (t.stopPropagation(), t.button === 0) {
        const e = {
          x: t.pageX,
          y: t.pageY
        };
        if (this.context) {
          const i = this._rootContainer.getBoundingClientRect(), s = this.context.xDirection(e, i), h = this.context.yDirection(e, i);
          this.updateRelativeMousePoint(e), this.isDraggingEdge ? this.renderDraggingEdge(e) : this.onDraggingNode(s, h);
        }
      }
    });
    n(this, "endDragging", (t) => {
      var r;
      (r = this.draggingElement) == null || r.remove();
      const e = {
        x: t.pageX,
        y: t.pageY
      };
      this.updateRelativeMousePoint(e);
      const i = {
        x: this._rootContainer.scrollLeft - this.originalScrollPosition.x,
        y: this._rootContainer.scrollTop - this.originalScrollPosition.y
      }, s = this.context.provider.scale || 1;
      let h;
      this.isDraggingEdge ? (h = this.findPotentialEdgeTarget(e), h && this.draggingNode.connect(h)) : this.draggingNode.setPoint(
        {
          x: this.draggingNode.x + this.context.xyDelta.x / s + i.x,
          y: this.draggingNode.y + this.context.xyDelta.y / s + i.y
        }
      ), l(this.editableGlass).withStyle({
        display: "none"
      }), l(this.context.provider.svgDndBackground).withStyle({
        display: "none"
      }), this.isDraggingEdge ? this.context.provider.endEdgeDragging(this.draggingNode, h) : this.context.provider.endNodeDragging(this.draggingNode), this.isDraggingEdge = !1;
    });
    n(this, "updateRelativeMousePoint", (t) => {
      const e = this._rootContainer.getBoundingClientRect();
      if (this.context.moveTo(t, e), !this.isDraggingEdge) {
        const i = this.context.lastBounds(), s = this.context.provider.getParentTopLeft(this.draggingNode);
        let h = 0, r = 0;
        i.left < s.x && (h = s.x - i.left), i.top < s.y && (r = s.y - i.top), this.context.moveTo({
          x: t.x + h,
          y: t.y + r
        }, e);
      }
    });
    n(this, "scrollIfNeeded", ({ xDirection: t, yDirection: e }) => {
      const i = this._rootContainer.getBoundingClientRect(), s = P(this.draggingElement);
      this.context.provider.resizeIfNeeded(s);
      let h = 0, r = 0;
      t === D.LeftToRight && s.right > i.right && (h = s.right - i.right), t === D.RightToLeft && s.left < i.left && (h = -(i.left - s.left)), e === B.TopToBottom && s.bottom >= i.bottom - 20 && (r = s.bottom - (i.bottom - 20)), e === B.BottomToTop && s.top < i.top && (r = -(i.top - s.top)), this._rootContainer.scrollLeft += h, this._rootContainer.scrollTop += r;
    });
    this._rootContainer = t, this._glassStyles = e, this.mapEdgeToPoints = i, this.buildGlass();
  }
  destory() {
    this.editableGlass.remove();
  }
  renderDraggingEdge(t) {
    let e = this.draggingNode;
    const i = this.findPotentialEdgeTarget(t);
    i && (e = i);
    const { source: s, target: h } = this.mapEdgeToPoints({
      source: this.draggingNode,
      target: e
    }), r = this.context.provider.scale || 1, d = v(this.context.provider.svgDndBackground.getBoundingClientRect(), r), a = v(this.draggingNodeParentBounds, r), p = {
      x: s.x + a.x - d.x,
      y: s.y + a.y - d.y
    }, y = {
      x: h.x + a.x,
      y: h.y + a.y
    }, m = {
      x: (e !== this.draggingNode ? y.x : g(t.x / r)) - d.x,
      y: (e !== this.draggingNode ? y.y : g(t.y / r)) - d.y
    }, L = (p.x + m.x) / 2, _ = (p.y + m.y) / 2, w = `M${p.x},${p.y} L${L},${_} L${m.x},${m.y}`;
    l(this.draggingElement).withAttributes({
      d: w
    });
  }
  findPotentialEdgeTarget(t) {
    var i;
    const e = this.eligibleEdgeConnectors.find((s) => Ot(t, s.bounds));
    return e && !((i = e.viewNode.dependencies) != null && i.some((s) => s === this.draggingNode.id)) && u(this.draggingNode.model.dagId).config.mode === R.WITH_JOINT_NODES && (!e.viewNode.dependencies || e.viewNode.dependencies.length === 0 || e.viewNode.joint) ? e.viewNode : null;
  }
  onDraggingNode(t, e) {
    const i = this.context.lastBounds();
    this.scrollIfNeeded({
      xDirection: t,
      yDirection: e
    }), l(this.draggingElement).withAbsolutePoint(
      {
        x: i.left,
        y: i.top
      }
    );
  }
}
const Pt = 200;
class j {
  constructor({ rootXy: t, mPoint: e, bounds: i, scale: s, provider: h }) {
    n(this, "mouseDownTimestamp");
    n(this, "originalBounds");
    n(this, "_originalPoint");
    n(this, "mrPoint");
    n(this, "originalOffset");
    n(this, "rootXy");
    n(this, "invalidDropping");
    n(this, "_provider");
    n(this, "dir");
    n(this, "_scale");
    n(this, "validDndThreshold");
    n(this, "moveTo", (t, e) => {
      this.mrPoint = {
        x: t.x - e.x,
        y: t.y - e.y
      };
    });
    n(this, "xDirection", (t, e) => {
      const i = t.x - e.left, s = (this.mrPoint || { x: 0 }).x;
      return s < i ? D.LeftToRight : s === i ? D.None : D.RightToLeft;
    });
    n(this, "yDirection", (t, e) => {
      const i = t.y - e.top;
      return (this.mrPoint || { y: 0 }).y < i ? B.TopToBottom : (this.mrPoint || { y: 0 }).y == i ? B.None : B.BottomToTop;
    });
    n(this, "allowDrop", () => {
      if (this.mouseDownTimestamp && new Date().getTime() - this.mouseDownTimestamp <= Pt)
        return !1;
      const t = this.xyDelta;
      return !(Math.abs(t.x) <= 5 && Math.abs(t.y) <= 5);
    });
    this.mouseDownTimestamp = new Date().getTime(), this.rootXy = t, this._scale = s;
    const { x: r, y: d } = t;
    this._originalPoint = {
      x: e.x - r,
      y: e.y - d
    }, this.originalBounds = {
      x: i.left,
      y: i.top,
      left: i.left,
      top: i.top,
      width: i.width,
      height: i.height,
      right: i.left + i.width,
      bottom: i.top + i.height
    }, this.originalOffset = {
      x: this._originalPoint.x - this.originalBounds.x,
      y: this._originalPoint.y - this.originalBounds.y
    }, this.mrPoint = this._originalPoint, this._provider = h, this.validDndThreshold = (h == null ? void 0 : h.validDndThreshold) || 3;
  }
  get originalPoint() {
    return this._originalPoint;
  }
  lastBounds(t = !1) {
    const e = this.xyDelta, { x: i, y: s } = { x: this.originalBounds.left + e.x, y: this.originalBounds.top + e.y }, h = t ? i - this.rootXy.x : i, r = t ? s - this.rootXy.y : s;
    return {
      ...this.originalBounds,
      x: h,
      y: r,
      left: h,
      top: r,
      right: h + this.originalBounds.width,
      bottom: r + this.originalBounds.height
    };
  }
  get xyDelta() {
    return {
      x: this.mrPoint.x - this._originalPoint.x,
      y: this.mrPoint.y - this._originalPoint.y
    };
  }
  topLeftDelta(t) {
    return {
      x: t.x - (this._originalPoint.x - this.originalOffset.x),
      y: t.y - (this._originalPoint.y - this.originalOffset.y)
    };
  }
  get provider() {
    return this._provider;
  }
  get point() {
    return this.mrPoint;
  }
}
const zt = "http://www.w3.org/2000/svg";
class $t {
  constructor(t, e, i) {
    n(this, "gridSize");
    n(this, "svg");
    n(this, "_scale");
    n(this, "_xArr");
    n(this, "_yArr");
    n(this, "xLines", []);
    n(this, "yLines", []);
    n(this, "_visible");
    n(this, "doLayout", () => {
      const t = this.svg.getBoundingClientRect(), e = v(t, this._scale || 1);
      this._xArr = [];
      for (let i = 0; i <= e.width; )
        this._xArr.push(i), i += this.gridSize;
      this._yArr = [];
      for (let i = 0; i <= e.height; )
        this._yArr.push(i), i += this.gridSize;
    });
    n(this, "getLines", (t = !1) => {
      const e = this.svg.getBoundingClientRect(), i = v(e, this._scale || 1);
      return (t ? this._yArr : this._xArr).map((r) => t ? {
        x1: 0,
        y1: r,
        x2: i.width,
        y2: r
      } : {
        x1: r,
        y1: 0,
        x2: r,
        y2: i.height
      });
    });
    n(this, "gridPoint", (t) => {
      const e = this.svg.getBoundingClientRect(), i = {
        x: g(t.x / this.scale),
        y: g(t.y / this.scale)
      }, s = v(e, this.scale), { xArr: h, yArr: r } = this, d = { column: -1, row: -1 };
      if (i.x >= s.left + h[0]) {
        for (let a = 0; a < h.length; a++)
          if (i.x < s.left + h[a]) {
            d.column = a - 1;
            break;
          }
        d.column === -1 && (d.column = h.length - 2), d.column > h.length - 2 && (d.column = h.length - 2);
      }
      if (i.y >= s.top + r[0]) {
        for (let a = 0; a < r.length; a++)
          if (i.y < s.top + r[a]) {
            d.row = a - 1;
            break;
          }
        d.row === -1 && (d.row = r.length - 2), d.row > r.length - 2 && (d.row = r.length - 2);
      }
      return d.column >= 0 && d.row >= 0 ? {
        x: h[d.column] + e.left,
        y: r[d.row] + e.top
      } : {
        x: e.left,
        y: e.top
      };
    });
    n(this, "render", () => {
      this._visible = !0, this.clear(), this.doLayout(), this.getLines().forEach((i) => {
        this.appendLine(i, !1);
      }), this.getLines(!0).forEach((i) => {
        this.appendLine(i, !0);
      });
    });
    this.gridSize = e, this.svg = t, this._scale = i || 1, this._visible = !1;
  }
  get visible() {
    return this._visible;
  }
  clear() {
    this.svg.innerHTML = "", this.xLines = [], this.yLines = [];
  }
  get xArr() {
    return this._xArr;
  }
  get yArr() {
    return this._yArr;
  }
  appendLine(t, e) {
    const i = document.createElementNS(zt, "line");
    i.setAttribute("class", "nice-dag-dnd-svg-layer-dash-line"), i.setAttribute("x1", `${t.x1}`), i.setAttribute("x2", `${t.x2}`), i.setAttribute("y1", `${t.y1}`), i.setAttribute("y2", `${t.y2}`), l(i).withAttributes({
      stroke: "#9a9a9a",
      "stroke-width": 1,
      "stroke-dasharray": "2, 4"
    }), e ? this.yLines.push(i) : this.xLines.push(i), this.svg.appendChild(i);
  }
  redraw() {
    const { xArr: t, yArr: e } = this;
    this.doLayout();
    const i = this.getLines();
    if (this._xArr.length > t.length)
      for (let h = 0; h < this._xArr.length; h++) {
        const r = i[h];
        h >= t.length && this.appendLine(r, !1);
      }
    for (let h = 0; h < i.length; h++) {
      const r = i[h];
      l(this.xLines[h]).withAttributes({
        x1: `${r.x1}`,
        x2: `${r.x2}`,
        y1: `${r.y1}`,
        y2: `${r.y2}`
      });
    }
    const s = this.getLines(!0);
    if (this._yArr.length > e.length)
      for (let h = 0; h < this._yArr.length; h++) {
        const r = s[h];
        h >= e.length && this.appendLine(r, !0);
      }
    for (let h = 0; h < s.length; h++) {
      const r = s[h];
      l(this.yLines[h]).withAttributes({
        x1: `${r.x1}`,
        x2: `${r.x2}`,
        y1: `${r.y1}`,
        y2: `${r.y2}`
      });
    }
  }
  set scale(t) {
    this._scale = t;
  }
}
class kt extends tt {
  constructor(e) {
    super(e);
    n(this, "_dnd");
    n(this, "_editing");
    n(this, "svgGridBkg");
    n(this, "svgDndBkg");
    n(this, "editorBkgContainer");
    n(this, "_grid");
    n(this, "glassStyles");
    n(this, "startEditing", () => {
      this._editing = !0, this.getAllNodes().forEach((e) => e.editing = !0), this._dnd.setEnabled(!0), this.setGridVisible(!0);
    });
    n(this, "stopEditing", () => {
      this._editing = !1, this.getAllNodes().forEach((e) => e.editing = !1), this._dnd.setEnabled(!1), this.setGridVisible(!1);
    });
    n(this, "startEdgeDragging", (e, i) => {
      if (this._editing) {
        l(this.svgDndBkg).withStyle({
          display: "block"
        });
        const s = this._rootContainer.getBoundingClientRect(), h = e.ref.getBoundingClientRect();
        this._dnd.withContext(new j({
          rootXy: {
            x: s.left,
            y: s.y
          },
          mPoint: {
            x: i.pageX,
            y: i.pageY
          },
          bounds: h,
          scale: this._scale,
          provider: this
        })).startEdgeDragging(e, i);
      }
    });
    n(this, "startNodeDragging", (e, i) => {
      if (this._editing) {
        l(this.svgDndBkg).withStyle({
          display: "block"
        }), e.editing = !0;
        const s = this._rootContainer.getBoundingClientRect(), h = e.ref.getBoundingClientRect();
        this._dnd.withContext(new j({
          rootXy: {
            x: s.left,
            y: s.y
          },
          mPoint: {
            x: i.pageX,
            y: i.pageY
          },
          bounds: h,
          scale: this._scale,
          provider: this
        })).startNodeDragging(e, i);
      }
    });
    this._dnd = new Y(this.mainLayer, e.glassStyles, this._config.mapEdgeToPoints), this.editorBkgContainer = T(this.mainLayer, yt).htmlElement, this.svgGridBkg = z(this.editorBkgContainer, null, `${this.uid}-${ft}`).withStyle({
      width: "100%",
      height: "100%"
    }).withClassNames(pt).svgElement, this.svgDndBkg = z(this.editorBkgContainer, null, `${this.uid}-${J}`).withClassNames(ut).withAbsolutePosition(K).withStyle({
      width: "100%",
      height: "100%",
      display: "none",
      "z-index": 99
    }).svgElement;
  }
  endNodeDragging() {
    this.fireMinimapChange();
  }
  endEdgeDragging() {
    this.fireMinimapChange();
  }
  get svgDndBackground() {
    return this.svgDndBkg;
  }
  onModelChange(e) {
    super.onModelChange(e), e.type === c.RESIZE ? this._editing && (this.doBackgroundLayout(), this._grid.redraw(), this.fireMinimapChange()) : e.type === c.REMOVE_NODE && this.fireMinimapChange();
  }
  get grid() {
    return this._grid;
  }
  get validDndThreshold() {
    return 3;
  }
  addJointNode(e, i, s = "root") {
    s === "root" ? this.rootModel.addNode(e, i, !0) : this.rootModel.findNodeById(s).addChildNode(e, i);
  }
  addNode(e, i, s = "root") {
    s === "root" ? this.rootModel.addNode(e, i) : this.rootModel.findNodeById(s).addChildNode(e, i);
  }
  withNodes(e) {
    const i = this.isDestoried;
    return super.withNodes(e), i && (this._dnd = new Y(this.mainLayer, this.glassStyles, this._config.mapEdgeToPoints), this._editing ? this.startEditing() : this.stopEditing()), this;
  }
  get editing() {
    return this._editing;
  }
  center(e) {
    return this._editing || (super.center(e), this.doBackgroundLayout(), this.setGridVisible(this._editing)), this;
  }
  doBackgroundLayout() {
    const e = this.zoomLayer.getBoundingClientRect(), { scale: i = 1 } = this, s = this.mainLayer.getBoundingClientRect(), h = {
      width: g(e.width / i),
      height: g(e.height / i)
    };
    e.width < s.width && (h.width = g(s.width / i)), e.height < s.height && (h.height = g(s.height / i));
    const r = {
      x: 0,
      y: 0,
      ...h
    };
    l(this.editorBkgContainer).withAbsolutePosition(r);
  }
  setGridVisible(e) {
    e ? this._grid.render() : this._grid.clear();
  }
  prettify() {
    const e = this.editing;
    this.stopEditing(), this.rootModel.doLayout(!0, !0), this.justifyCenter(this.parentSize), e && this.startEditing();
  }
  resizeBackground(e, i) {
    const s = e.getBoundingClientRect(), h = i.x + i.width - s.x, r = i.y + i.height - s.y;
    if (s.width < h) {
      const d = g(h / (this._scale || 1));
      l(this.svgDndBackground).withWidth(d), l(this.svgGridBkg).withWidth(d);
    }
    if (s.height < r) {
      const d = g(r / (this._scale || 1));
      l(this.svgDndBackground).withHeight(d), l(this.svgGridBkg).withHeight(d);
    }
    return s.width < h || s.height < r;
  }
  resizeIfNeeded(e) {
    const i = this.resizeBackground(this.svgGridBkg, e);
    return i && this._grid.redraw(), i;
  }
  render() {
    var e;
    super.render(), this.doBackgroundLayout(), this._grid = new $t(this.svgGridBkg, (e = this.config.gridConfig) == null ? void 0 : e.size, this._scale), this.setGridVisible(this._editing);
  }
  justifyCenter(e) {
    if (!this._editing && e) {
      const i = this.zoomLayer.getBoundingClientRect();
      let s = 0, h = 0, r = 0, d = 0;
      e.width > i.width && (s = (e.width - i.width) / 2, r = g(e.width / this.scale)), e.height > i.height && (h = (e.height - i.height) / 2, d = g(e.height / this.scale)), this.rootView.justifySize({ width: r, height: d }), (s > 0 || h > 0) && this.rootModel.setRootOffset({
        offsetX: g(s / this.scale),
        offsetY: g(h / this.scale)
      }), this.doBackgroundLayout();
    }
  }
  setScale(e) {
    super.setScale(e), this.editorBkgContainer.style.transform = `scale(${e})`, this.editorBkgContainer.style.transformOrigin = "left top", this.doBackgroundLayout(), this._grid.scale = e, this.grid.visible && this._grid.redraw();
  }
  getParentTopLeft(e) {
    const i = e.ref.parentElement.getBoundingClientRect();
    return {
      x: i.left,
      y: i.top
    };
  }
  destory() {
    super.destory(), this._dnd.destory();
  }
}
function Gt(o, t = !1) {
  const e = t ? new kt(o) : new tt(o);
  return mt(e.id, e), e;
}
const Yt = {
  use: u,
  init: Gt
};
export {
  Yt as default
};
